import script from "./SportSectionDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SportSectionDetail.vue?vue&type=script&setup=true&lang=js"

import "./SportSectionDetail.vue?vue&type=style&index=0&id=25e9bccf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25e9bccf"]])

export default __exports__